import { render, staticRenderFns } from "./repositoryCheckList.vue?vue&type=template&id=180f233d&scoped=true"
import script from "./repositoryCheckList.vue?vue&type=script&lang=js"
export * from "./repositoryCheckList.vue?vue&type=script&lang=js"
import style0 from "./repositoryCheckList.vue?vue&type=style&index=0&id=180f233d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180f233d",
  null
  
)

export default component.exports